module.exports = __webpack_public_path__ + "img/car_00012.50d56a81.jpg";